import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import '../../css/signIn.css';


const SignIn = () => {
  const navigate = useNavigate();

  return (
    <div className="signin">
      <div className="container">
        <div className="signin-content">
            <div className="signin-left">
                <div className="signin-icon">
                    <i className="fas fa-tag"></i> {/* Font Awesome tag icon */}
                </div>
                <p className="signin-text">
                    Members save <span>10% or more</span> on over 100,000 hotels worldwide when signed in
                </p>
            </div>
            <div className="signin-right">
                <button
                className="signin-btn"
                onClick={() => navigate("/")}
                >
                Sign in
                </button>
            </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;